import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, DatePicker, Table, InputNumber  } from 'antd'
import NumberFormat from 'react-number-format'
import Currency from 'react-currency-formatter';
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
import { getTotal } from '../../utils'
const axios = require('axios')
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const RangePicker = DatePicker.RangePicker;

class IncomeNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            employees: [],
            filterByHotel: '',
            commission_amount: 0,
            commission_sales: 0,
            commission_occupation: 0
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        /*if (localStorage.getItem('hotelConta'))
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.incomeType === 'trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.incomeId) {
            // Inicialización de valores para actualizar

            this.props.dispatch({type: 'app/showLoadingTable'})

            get('Income', this.props.incomeId, {include: 'hotel,employee,employee.parent_category'}).then((resp) => {

                resp.requestedAt = moment(new Date(resp.requestedAt.iso), 'YYYY/MM/DD');
                if (resp.hotel) resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};

                // Asignamos los registros del catálogo según si es una categoría principal o una subcategoría
                if (resp.employee && resp.employee.parent_category) {
                    resp.employee.parent_category.children = [resp.employee];

                    this.setState({ 
                        companies: [resp.employee.parent_category], 
                        company_selected: resp.employee.parent_category,
                        employee_selected: resp.employee 
                    })

                    resp.company = {key: resp.employee.parent_category.objectId, label: resp.employee.parent_category.name};
                    resp.employee_list = {key: resp.employee.objectId, label: resp.employee.name};

                } else {
                    resp.employee.children = [];

                    this.setState({ 
                        companies: [resp.employee],
                        company_selected: resp.employee
                    })
                    resp.company = {key: resp.employee.objectId, label: resp.employee.name};
                }
                
                this.props.form.setFieldsValue(resp);
                this.props.dispatch({type: 'app/hideLoadingTable'})
            })
        }

        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })


        // Si el usuario administra solo un hotel, entonces se asigna desde el inicio el array de empleados de un dueño
        //if (this.state.currentHotel) {
        //    this.setState({ filterByHotel: this.state.currentHotel.objectId })

            // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de cliente
            // en éste caso no estamos consultando por nombre sino por hotel
            this.fetchEmployees('', (employees) => {
                this.setState({ employees: employees })
            });
        //}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        this.props.form.setFieldsValue({ company: {key: ''} });      

        if (value && value.key && !value.label) {
            this.fetchHotel(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }

        // Key trae el ID del hotel, entonces se consulta los clientes de dicho hotel
        if (value && value.key && value.label) {
            this.setState({ filterByHotel: value.key })

            setTimeout(() => {
                // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de cliente
                // en éste caso no estamos consultando por nombre sino por hotel
                this.fetchEmployees('', (employees) => {
                    this.setState({ employees: employees })
                });
            }, 100);
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            //callback('Por favor, elija el hotel al que pertenece el cliente!');

            this.setState({ filterByHotel: null })
            setTimeout(() => {
                this.fetchEmployees('', (employees) => {
                    this.setState({ employees: employees })
                });
            }, 100);

            callback();

        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchEmployees (value, callback) {  
        this.props.dispatch({type: 'app/showLoadingTable'})

        setTimeout(() => {
            
            // Query
            let query = {};

            if (this.state.currentHotel) {
                query.type = 'hotel';
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
            }

            if (this.state.filterByHotel) {
                query.type = 'hotel';
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}
            }

            if (!this.state.currentHotel && !this.state.filterByHotel) {
                query.type = 'trie';
                query.job = 'recepcionista';
            } else {
                query.type = 'hotel';
                query.job = 'camarista';
            }

            all('Employee', {where: query}).then((d) => {
                this.props.dispatch({type: 'app/hideLoadingTable'})

                const results = d.results;
                callback(results);

                this.state.employees.map(item => {
                    let data = {};
                    data[item.objectId + '_commission_percent'] = Number(parseFloat(100 / this.state.employees.length).toFixed(2));

                    this.props.form.setFieldsValue(data);
                });

            }).catch(e => {
                message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
            });

        }, 500);
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    }


    /**
    * Calcula el monto de comisión según la ocupación
    */
    handleOccupation (value) {
        var commission_amount = Number(parseFloat(this.state.commission_sales * (value / 1000)).toFixed(2));
        this.setState({ commission_amount: commission_amount });

        this.handlePercentCommision();
    }


    /**
    * Asigna el nuevo monto según lo obtenido en el campo de porcentaje del empleado
    */
    handlePercentCommision (value) {

        if (this.state.employees.length > 0) {

            setTimeout(function() {
                this.state.employees.map(item => {
                    let data = {};
                    data[item.objectId + '_commission_amount'] = '$' + parseFloat(this.state.commission_amount * (this.props.form.getFieldValue(item.objectId + '_commission_percent') / 100)).toFixed(2);

                    this.props.form.setFieldsValue(data);
                });
            }.bind(this), 100);
        }
    }


    /**
    * Asigna el nuevo porcentaje según lo obtenido en el campo del monto del empleado
    */
    handleAmountCommision (value) {

        if (this.state.employees.length > 0) {

            setTimeout(function() {
                this.state.employees.map(item => {
                    let data = {};
                    data[item.objectId + '_commission_percent'] = Number(parseFloat((this.props.form.getFieldValue(item.objectId + '_commission_amount').replace(/[^\d.]/g, '') / this.state.commission_amount) * 100).toFixed(2));

                    this.props.form.setFieldsValue(data);
                });
            }.bind(this), 100);
        }
    }


    /**
    * Obtiene el total de ingresos (ventas del hotel) y calcula el monto de comisión
    */
    setAmountComission (value) {
        if (this.props.form.getFieldValue('occupation')) {
            let query = {
                $or: [
                    {type: 'payments'},
                    {
                        expense: {
                            $inQuery: {
                                where: {
                                    isPayment: true
                                },
                                className: 'ExpenseType'
                            }
                        }
                    }
                ],
                status: {$ne: 'requested'},
                requestedAt: {
                    $gte: {__type: 'Date', iso: new Date(moment(value).subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(value).subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            };

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            this.props.dispatch({type: 'app/showLoadingTable'})
            
            all('Income', {
                where: query,
                include: 'hotel,payment,expense'
            }).then(resp => {
                this.props.dispatch({type: 'app/hideLoadingTable'})
                console.log(resp);

                let total_income = getTotal(resp.results, 'amount_income');
                let total_expense = getTotal(resp.results, 'amount_expense');

                var commission_occupation = this.props.form.getFieldValue('occupation') / 1000;
                var commission_sales = Number(parseFloat((total_income - total_expense) * 0.3 * 0.25).toFixed(2));
                var commission_amount = Number(parseFloat(commission_sales * commission_occupation).toFixed(2));

                this.setState({
                    commission_occupation: commission_occupation,
                    commission_sales: commission_sales,
                    commission_amount: commission_amount
                });

                this.handlePercentCommision();
            });
        }
    }


    /**
    * Crea los movimientos individualmente
    */
    createIncome (data) {
        // Se crea un registro en las cajas por la nómina de cada empleado
        create('Income', data).then(resp => {

            _.extend(data, resp);

        }).catch(e => {
            this.createIncome(data);

        });
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.requestedAt = {__type: 'Date', iso: new Date(values.requestedAt).toISOString()};
            values.occupation ? data.occupation = values.occupation : null;
            data.notes = values.notes;
            data.type = 'commission';
            data.chargedTo = this.props.incomeType;
            data.employees = [];

            if (this.state.currentHotel) {
                data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            _.map(this.state.employees, (item, key) => {

                // Model
                let employee = {};
                employee.objectId = item.objectId;
                employee.name = item.name;

                values[employee.objectId + '_commission_percent'] ? employee.commission_percent = values[employee.objectId + '_commission_percent'] : employee.commission_percent = 0;
                values[employee.objectId + '_commission_amount'] ? employee.commission_amount = Number(parseFloat(values[employee.objectId + '_commission_amount'].replace(/[^\d.]/g, '')).toFixed(2)) : employee.commission_amount = 0;

                data.employees.push(employee);
            });

            data.commission_percent = getTotal(data.employees, 'commission_percent');
            data.commission_amount = getTotal(data.employees, 'commission_amount');

            if (data.chargedTo === 'hotel' && data.commission_percent !== 100) {
                message.error('La suma total de las comisiones es del ' + data.commission_percent + '%. Debe asignar el 100%') 
                return;
            }
            
            if (!this.props.incomeId) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Commission', data).then(resp => {

                    // Corremos el array de empleados para crear los gastos correspondiente
                    _.map(data.employees, (employee, key) => {

                        // Model Income
                        let income = {};
                        income.requestedAt = data.requestedAt;
                        income.createdBy = data.createdBy;
                        income.notified = false;
                        income.status = 'requested';
                        income.adjustment = 0;
                        income.notEdit = true;
                        income.commission = {__type: 'Pointer', className: 'Commission', objectId: resp.objectId};
                        income.amount_income = 0;
                        income.amount_expense = employee.commission_amount;
                        income.items = 'COMISIÓN ' + employee.name + (this.state.currentHotel ? ' del hotel ' + this.state.currentHotel.name : '');

                        if (data.hotel)
                            income.hotel = data.hotel;

                        if (data.chargedTo === 'hotel') {
                            /*income.type = 'others';*/
                            income.type = 'cash_funds_trie';
                            this.createIncome(income);

                            if (key === data.employees.length - 1) {

                                let incomeEntregaTRIE = {...income};
                                incomeEntregaTRIE.type = 'others';
                                incomeEntregaTRIE.items = 'EFECTIVO ENTREGADO A TRIE';
                                incomeEntregaTRIE.amount_expense = getTotal(data.employees, 'commission_amount');

                                this.createIncome(incomeEntregaTRIE);

                                let incomeIngresoTRIE = {...income};
                                incomeIngresoTRIE.type = 'cash_funds_trie';
                                incomeIngresoTRIE.items = 'INYECCIÓN DE EFECTIVO PARA COMISIONES DEL HOTEL ' + (this.state.currentHotel ? this.state.currentHotel.name : '');
                                incomeIngresoTRIE.amount_income = getTotal(data.employees, 'commission_amount');
                                incomeIngresoTRIE.amount_expense = 0;

                                this.createIncome(incomeIngresoTRIE);
                            }

                        } else {
                            income.status = 'pending';
                            income.type = 'cash_funds_trie';
                            this.createIncome(income);
                        }
                    });

                    _.extend(data, resp);

                    if (values.hotel && values.hotel.key)
                        data.hotel = {objectId: values.hotel.key, name: values.hotel.label};

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    var keys = _.without(_.keys(values), 'hotel');
                    this.props.form.resetFields(keys);

                    axios({
                        url: config.api + 'jobs/set_hotel_totals',
                        method: 'POST',
                        headers: {
                            'X-Parse-Application-Id': config.appId,
                            'X-Parse-Master-Key': config.masterKey
                        },
                    });

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.props.incomeId;
                this.props.dispatch({type: 'income/update', payload: data})

                axios({
                    url: config.api + 'jobs/set_hotel_totals',
                    method: 'POST',
                    headers: {
                        'X-Parse-Application-Id': config.appId,
                        'X-Parse-Master-Key': config.masterKey
                    },
                });
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div>
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            <div className="col-md-4">
                                <FormItem label="Fecha del pago" hasFeedback>
                                    {this.props.form.getFieldDecorator('requestedAt', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la fecha del pago'
                                        }]
                                    })(
                                        <DatePicker 
                                            format="DD-MM-YYYY"
                                            onChange={resp => {
                                                this.setAmountComission(resp);
                                            }} />
                                    )}
                                </FormItem>
                            </div>

                            {this.props.incomeType === 'hotel'
                                ? <div className="col-md-4">
                                    <FormItem label="% Ocupación" hasFeedback>
                                        {this.props.form.getFieldDecorator('occupation', {
                                            initialValue: 100
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')}
                                                onChange={this.handleOccupation.bind(this)}
                                                className="ant-input ant-input-lg"
                                            />
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }

                            {this.props.incomeType === 'hotel'
                                ? <div className="col-md-12 marginTop20 marginBottom30">
                                    <h4>
                                        <span className="color-primary">Monto Comisión: </span>
                                        <Currency quantity={this.state.commission_amount} currency="USD" />
                                    </h4>
                                </div>
                                : ''
                            }

                            {this.state.employees.length > 0
                                ? <div className="col-md-12">
                                    <Table 
                                        dataSource={this.state.employees} 
                                        rowKey="objectId" 
                                        size="small" 
                                        pagination={false}>

                                        <Column title="Nombre" key="name" render={(item) => (
                                            <span>{item.name}</span>
                                        )}/>

                                        {this.props.incomeType === 'hotel'
                                            ? <Column title="% Comisión" key="commission_percent" width={90} render={(item) => (
                                                <FormItem style={{marginBottom: 0}}>
                                                    {this.props.form.getFieldDecorator(item.objectId + '_commission_percent', {
                                                        initialValue: 0
                                                    })(
                                                        <InputNumber
                                                            min={0}
                                                            max={100}
                                                            formatter={value => `${value}%`}
                                                            parser={value => value.replace('%', '')}
                                                            onChange={this.handlePercentCommision.bind(this)}
                                                            className="ant-input ant-input-lg"
                                                        />
                                                    )}
                                                </FormItem>
                                            )}/>
                                            : ''
                                        }

                                        <Column title="Comisión" key="commission_amount" width={100} render={(item) => (
                                            <FormItem style={{marginBottom: 0}}>
                                                {this.props.form.getFieldDecorator(item.objectId + '_commission_amount', {
                                                    initialValue: '$0'
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        allowNegative={false}
                                                        onChange={this.handleAmountCommision.bind(this)}
                                                        className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        )}/>
                                    </Table>  
                                </div>
                                : ''
                            }

                            <div className="col-md-12">
                                <FormItem label="Observaciones" hasFeedback>
                                    {this.props.form.getFieldDecorator('notes')(<TextArea rows={3} />)}
                                </FormItem>
                            </div>
                            
                        </div>

                        <div className="row text-center">
                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Guardar
                            </Button>
                        </div>
                    </Spin>
                </Form>
            </div>
        )
    }
}

IncomeNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IncomeNew))


// WEBPACK FOOTER //
// ./src/components/incomes/commissionNew.js